import { call, put } from 'redux-saga/effects';
import { ApiError } from 'store/api/types';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import {
  fetchOrganisationContactsFailure,
  fetchOrganisationContactsSuccess,
} from '../actions';
import {
  GetOrganisationContactsResponse,
  getOrganisationContacts,
} from '../api';
import { FetchOrganisationContactsRequestAction } from '../types';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchOrganisationContactsSaga(
  action: FetchOrganisationContactsRequestAction
) {
  try {
    let err: ApiError | null;
    const { connectionId } = action.payload;

    const response: GetOrganisationContactsResponse = yield call(
      getOrganisationContacts,
      connectionId
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const contacts = response.data.contacts;
    yield put(fetchOrganisationContactsSuccess(connectionId, contacts));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      //yield put(turnMessageOn(message));
      console.log('fetchOrganisationContactsSaga error', error);
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchOrganisationContactsFailure());
  }
}
